import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SiteService } from '../site.service';
import { HolidayListVm } from '../../shared/generated/Sites/Models/Holidays/HolidayListVm';

@Component({
    selector: 'pcg-site-holidays',
    templateUrl: './site-holidays.component.html',
    styleUrls: ['./site-holidays.component.scss'],
    standalone: false
})
export class SiteHolidaysComponent implements OnInit {

	model: HolidayListVm;
	model$: Observable<HolidayListVm>;

	constructor(
        private siteService: SiteService
        , private modalService: NgbModal
    ) { }

	ngOnInit() { this.getHolidays(); }
	getHolidays() { this.model$ = this.siteService.getHolidays().pipe(tap((model: HolidayListVm) => { this.model = model; })); }
	dismiss() { this.modalService.dismissAll(); }
}
